(function() {
  // ============================================================
  // VIZUALS — Framing Upsell Popup v2
  // ============================================================

  const PRICE_DIFFERENCES = {
    '30x40': 74.60,
    '40x50': 90.40,
    '45x60': 94.40,
    '50x70': 109
  };

  const UNFRAMED_VALUE = 'Unframed';

  // ============================================================
  // STYLES
  // ============================================================
  const styles = `
    #vz-upsell-overlay {
      display: none;
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(26, 26, 26, 0.7);
      z-index: 99999;
      align-items: center;
      justify-content: center;
      padding: 20px;
      box-sizing: border-box;
    }
    #vz-upsell-overlay.vz-active {
      display: flex;
    }
    #vz-upsell-modal {
      background: #F5F0E8;
      border-radius: 12px;
      max-width: 420px;
      width: 100%;
      overflow: hidden;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
      font-family: 'Jost', Arial, sans-serif;
      position: relative;
      animation: vz-slide-up 0.3s ease;
    }
    @keyframes vz-slide-up {
      from { transform: translateY(20px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
    #vz-upsell-close {
      position: absolute;
      top: 14px; right: 16px;
      background: none;
      border: none;
      cursor: pointer;
      font-size: 20px;
      color: #C4A882;
      line-height: 1;
      padding: 4px;
      z-index: 1;
    }
    #vz-upsell-close:hover { color: #F5F0E8; }
    .vz-modal-header {
      background: #1A1A1A;
      padding: 20px 24px 16px;
      text-align: center;
    }
    .vz-modal-header .vz-social-proof {
      font-size: 11px;
      font-weight: 400;
      color: #C4A882;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      margin-bottom: 10px;
      display: block;
    }
    .vz-modal-header h2 {
      font-family: 'Bricolage Grotesque', Arial, sans-serif;
      font-size: 22px;
      font-weight: 700;
      color: #F5F0E8;
      line-height: 1.2;
      letter-spacing: -0.02em;
      margin: 0 0 6px;
    }
    .vz-modal-header h2 span { color: #C4A882; }
    .vz-modal-header p {
      font-size: 13px;
      font-weight: 300;
      color: #C4A882;
      margin: 0;
      line-height: 1.5;
    }
    .vz-modal-body { padding: 20px 24px; }
    .vz-frame-selector {
      display: flex;
      gap: 10px;
      margin-bottom: 20px;
    }
    .vz-frame-option {
      flex: 1;
      border: 1.5px solid #C4A882;
      border-radius: 8px;
      padding: 12px 10px;
      text-align: center;
      cursor: pointer;
      background: #fff;
      transition: all 0.2s ease;
    }
    .vz-frame-option.vz-selected {
      border-color: #1A1A1A;
      background: #F5F0E8;
    }
    .vz-frame-swatch {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin: 0 auto 8px;
      border: 1.5px solid rgba(0,0,0,0.1);
    }
    .vz-frame-name {
      font-family: 'Bricolage Grotesque', Arial, sans-serif;
      font-size: 12px;
      font-weight: 600;
      color: #1A1A1A;
      letter-spacing: 0.04em;
      display: block;
      margin-bottom: 2px;
    }
    .vz-frame-price {
      font-size: 11px;
      font-weight: 300;
      color: #8B6E4E;
    }
    .vz-trust-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 12px 0;
      border-top: 0.5px solid #C4A882;
      border-bottom: 0.5px solid #C4A882;
    }
    .vz-trust-item { text-align: center; flex: 1; }
    .vz-trust-item span {
      font-size: 10px;
      font-weight: 300;
      color: #1a1a1a;
      line-height: 1.4;
      display: block;
    }
    .vz-trust-item .vz-trust-icon { font-size: 16px; margin-bottom: 4px; color: #C4A882; }
    .vz-btn-upgrade {
      width: 100%;
      background: #1A1A1A;
      color: #F5F0E8;
      border: none;
      border-radius: 6px;
      padding: 15px 20px;
      font-family: 'Bricolage Grotesque', Arial, sans-serif;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      cursor: pointer;
      margin-bottom: 10px;
      transition: background 0.2s ease;
    }
    .vz-btn-upgrade:hover { background: #3D2B1A; }
    .vz-btn-upgrade:disabled { opacity: 0.6; cursor: not-allowed; }
    .vz-btn-sub {
      display: block;
      font-family: 'Jost', Arial, sans-serif;
      font-size: 11px;
      font-weight: 300;
      letter-spacing: 0.04em;
      color: #C4A882;
      margin-top: 3px;
      text-transform: none;
    }
    .vz-btn-secondary {
      display: block;
      width: 100%;
      background: none;
      border: none;
      font-family: 'Jost', Arial, sans-serif;
      font-size: 12px;
      font-weight: 300;
      color: #8B6E4E;
      text-align: center;
      cursor: pointer;
      padding: 8px;
      text-decoration: underline;
      text-underline-offset: 3px;
    }
    .vz-btn-secondary:hover { color: #1A1A1A; }
    @media (max-width: 480px) {
      #vz-upsell-modal { border-radius: 16px 16px 0 0; }
      #vz-upsell-overlay { align-items: flex-end; padding: 0; }
    }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = styles;
  document.head.appendChild(styleEl);

  // ============================================================
  // BUILD MODAL
  // ============================================================
  const overlay = document.createElement('div');
  overlay.id = 'vz-upsell-overlay';
  overlay.innerHTML = `
    <div id="vz-upsell-modal">
      <button id="vz-upsell-close" aria-label="Close">&times;</button>
      <div class="vz-modal-header">
        <span class="vz-social-proof">&#9733; Trusted by 5,000+ fans</span>
        <h2>Your print deserves<br>a <span>proper home.</span></h2>
        <p>Upgrade to framed — arrives ready to hang, no tools needed.</p>
      </div>
      <div class="vz-modal-body">
        <div class="vz-frame-selector">
          <div class="vz-frame-option vz-selected" data-frame="Black">
            <div class="vz-frame-swatch" style="background:#1C1C1C;"></div>
            <span class="vz-frame-name">Black</span>
            <span class="vz-frame-price" id="vz-price-black"></span>
          </div>
          <div class="vz-frame-option" data-frame="Wood">
            <div class="vz-frame-swatch" style="background:#C4A882;"></div>
            <span class="vz-frame-name">Wood</span>
            <span class="vz-frame-price" id="vz-price-wood"></span>
          </div>
        </div>
        <div class="vz-trust-row">
          <div class="vz-trust-item">
            <span class="vz-trust-icon">&#10003;</span>
            <span>Real wood<br>frame</span>
          </div>
          <div class="vz-trust-item">
            <span class="vz-trust-icon">&#10003;</span>
            <span>Ready<br>to hang</span>
          </div>
          <div class="vz-trust-item">
            <span class="vz-trust-icon">&#10003;</span>
            <span>2 year<br>warranty</span>
          </div>
        </div>
        <button class="vz-btn-upgrade" id="vz-btn-upgrade">
          Yes! Frame My Print
          <span class="vz-btn-sub" id="vz-upgrade-price-label"></span>
        </button>
        <button class="vz-btn-secondary" id="vz-btn-decline">No thanks, I just want the poster</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  // ============================================================
  // STATE
  // ============================================================
  let selectedFrame = 'Black';
  let currentVariantId = null;
  let currentSize = null;
  let isProcessing = false;
  let pendingFormData = null;
  let pendingFormElement = null;
  let pendingActiveElement = null;

  // ============================================================
  // GET PRODUCT DATA
  // ============================================================
  function getProduct() {
    try {
      // Method 1: ShopifyAnalytics
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product;
      }
    } catch(e) {}
    return null;
  }

  // ============================================================
  // GET SELECTED VARIANT ID FROM FORM
  // ============================================================
  function getVariantIdFromForm(form) {
    // Try hidden input named 'id'
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) return parseInt(idInput.value);

    // Try select named 'id'
    const idSelect = form.querySelector('select[name="id"]');
    if (idSelect && idSelect.value) return parseInt(idSelect.value);

    // Try URL param
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) return parseInt(variantParam);

    return null;
  }

  // ============================================================
  // CHECK IF VARIANT IS UNFRAMED
  // Using public_title which contains the option values
  // e.g. "16x20\" / 40x50cm / Unframed"
  // ============================================================
  function isVariantUnframed(variantId) {
    const product = getProduct();
    if (!product || !product.variants) return false;
    const variant = product.variants.find(v => v.id === variantId);
    if (!variant) return false;
    const title = variant.public_title || variant.name || '';
    return title.includes(UNFRAMED_VALUE);
  }

  // ============================================================
  // GET SIZE FROM VARIANT
  // ============================================================
  function getSizeFromVariant(variantId) {
    const product = getProduct();
    if (!product || !product.variants) return null;
    const variant = product.variants.find(v => v.id === variantId);
    if (!variant) return null;
    const title = variant.public_title || variant.name || '';
    // Extract size — matches patterns like "12x16", "16x20", "18x24", "20x28"
    const match = title.match(/(\d+x\d+)/);
    return match ? match[1] : null;
  }

  // ============================================================
  // GET PRICE DIFFERENCE FOR SIZE
  // ============================================================
  function getPriceDiff(size) {
    if (!size) return null;
    for (const key in PRICE_DIFFERENCES) {
      if (size.includes(key)) return PRICE_DIFFERENCES[key];
    }
    return null;
  }

  // ============================================================
  // FIND FRAMED VARIANT
  // Matches same size but with selected frame colour
  // Uses public_title which contains all option values
  // ============================================================
  function findFramedVariant(size, frameColour) {
    const product = getProduct();
    if (!product || !product.variants) return null;
    return product.variants.find(v => {
      const title = v.public_title || v.name || '';
      return title.includes(size) && title.includes(frameColour) && !title.includes(UNFRAMED_VALUE);
    });
  }

  // ============================================================
  // UPDATE MODAL UI
  // ============================================================
  function updateModal(size) {
    const diff = getPriceDiff(size);
    const priceText = diff ? `+$${diff}` : '';
    const labelText = diff ? `Add a ${selectedFrame} frame for only +$${diff}` : `Upgrade to ${selectedFrame} frame`;

    document.getElementById('vz-price-black').textContent = priceText;
    document.getElementById('vz-price-wood').textContent = priceText;
    document.getElementById('vz-upgrade-price-label').textContent = labelText;
  }

  // ============================================================
  // SHOW / HIDE MODAL
  // ============================================================
  function showModal(variantId, size) {
    currentVariantId = variantId;
    currentSize = size;
    selectedFrame = 'Black';
    isProcessing = false;

    // Reset frame UI
    document.querySelectorAll('.vz-frame-option').forEach(el => {
      el.classList.toggle('vz-selected', el.dataset.frame === 'Black');
    });

    // Reset button
    const btn = document.getElementById('vz-btn-upgrade');
    btn.disabled = false;
    btn.innerHTML = `Yes! Frame My Print <span class="vz-btn-sub" id="vz-upgrade-price-label"></span>`;

    const declineBtn = document.getElementById('vz-btn-decline');
    declineBtn.disabled = false;
    declineBtn.textContent = 'No thanks, I just want the poster';

    updateModal(size);
    overlay.classList.add('vz-active');
    document.body.style.overflow = 'hidden';
  }

  function hideModal() {
    overlay.classList.remove('vz-active');
    document.body.style.overflow = '';
    isProcessing = false;
    pendingFormData = null;
    pendingFormElement = null;
    pendingActiveElement = null;
  }

  // ============================================================
  // ADD TO CART AND RENDER MONOCHROME'S NATIVE CART DRAWER
  // ============================================================
  function buildCartFormData(variantId) {
    const formData = new FormData();

    if (pendingFormData) {
      pendingFormData.forEach((value, key) => {
        if (key !== 'id' && key !== 'sections' && key !== 'sections_url') {
          formData.append(key, value);
        }
      });
    }

    formData.set('id', variantId);
    if (!formData.has('quantity')) formData.set('quantity', 1);

    return formData;
  }

  function dispatchCartEvents(formData, formElement, sectionId) {
    document.dispatchEvent(
      new CustomEvent('variant:add', {
        detail: {
          variant: { id: formData.get('id') },
          quantity: Number(formData.get('quantity') || 1),
          formElement: formElement,
          sectionId: sectionId
        }
      })
    );

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'vizuals-frame-upsell',
        productVariantId: formData.get('id')
      });
    }

    const cartUrl = window.routes && window.routes.cart_url
      ? `${window.routes.cart_url}.js`
      : '/cart.js';

    fetch(cartUrl)
      .then(response => response.json())
      .then(cart => {
        document.dispatchEvent(
          new CustomEvent('cart:change', {
            detail: { cart: cart, sectionId: sectionId }
          })
        );
      })
      .catch(error => {
        console.error('Vizuals upsell: could not fetch cart state', error);
      });
  }

  function addVariantToCart(variantId) {
    const cartDrawer = document.querySelector('cart-drawer');
    const formData = buildCartFormData(variantId);
    const formElement = pendingFormElement;
    const productForm = formElement ? formElement.closest('product-form') : null;
    const sectionId = productForm ? productForm.dataset.source : null;

    const config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : {
          method: 'POST',
          headers: { Accept: 'application/javascript' }
        };

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function' &&
      typeof cartDrawer.renderContents === 'function'
    ) {
      const sectionIds = cartDrawer.getSectionsToRender().map(section => section.id);
      formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);

      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(pendingActiveElement || document.activeElement);
      }
    }

    config.body = formData;

    const addUrl = window.routes && window.routes.cart_add_url
      ? window.routes.cart_add_url
      : '/cart/add.js';

    return fetch(addUrl, config)
      .then(async response => {
        const data = await response.json();

        if (!response.ok || data.status) {
          const description = data.description || data.message || 'Unable to add this item to the cart.';
          throw new Error(typeof description === 'string' ? description : JSON.stringify(description));
        }

        dispatchCartEvents(formData, formElement, sectionId);

        if (cartDrawer && data.sections) {
          cartDrawer.renderContents(data);
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        }

        return data;
      });
  }

  // ============================================================
  // FRAME SELECTOR
  // ============================================================
  document.querySelectorAll('.vz-frame-option').forEach(option => {
    option.addEventListener('click', function() {
      if (isProcessing) return;
      selectedFrame = this.dataset.frame;
      document.querySelectorAll('.vz-frame-option').forEach(el => {
        el.classList.toggle('vz-selected', el.dataset.frame === selectedFrame);
      });
      const diff = getPriceDiff(currentSize);
      const label = document.getElementById('vz-upgrade-price-label');
      if (label) {
        label.textContent = diff
          ? `Add a ${selectedFrame} frame for only +$${diff}`
          : `Upgrade to ${selectedFrame} frame`;
      }
    });
  });

  // ============================================================
  // UPGRADE BUTTON
  // ============================================================
  document.getElementById('vz-btn-upgrade').addEventListener('click', function() {
    if (isProcessing) return;
    isProcessing = true;

    const framedVariant = findFramedVariant(currentSize, selectedFrame);
    if (!framedVariant) {
      console.warn('Vizuals upsell: could not find framed variant for', currentSize, selectedFrame);
      hideModal();
      return;
    }

    this.disabled = true;
    this.innerHTML = 'Adding to cart...<span class="vz-btn-sub">Just a moment</span>';

    addVariantToCart(framedVariant.id)
      .then(() => { hideModal(); })
      .catch(err => {
        console.error('Vizuals upsell: cart add failed', err);
        hideModal();
      });
  });

  // ============================================================
  // DECLINE BUTTON
  // ============================================================
  document.getElementById('vz-btn-decline').addEventListener('click', function() {
    if (isProcessing) return;
    isProcessing = true;

    this.textContent = 'Adding...';

    addVariantToCart(currentVariantId)
      .then(() => { hideModal(); })
      .catch(() => { hideModal(); });
  });

  // ============================================================
  // CLOSE
  // ============================================================
  document.getElementById('vz-upsell-close').addEventListener('click', hideModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) hideModal();
  });

  // ============================================================
  // INTERCEPT FORM SUBMIT
  // ============================================================
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    if (form.dataset.vzBypass === 'true') return;

    const variantId = getVariantIdFromForm(form);
    if (!variantId) return;

    if (isVariantUnframed(variantId)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      pendingFormData = new FormData(form);
      pendingFormElement = form;
      pendingActiveElement = document.activeElement;
      const size = getSizeFromVariant(variantId);
      showModal(variantId, size);
    }
  }, true);

  console.log('Vizuals frame upsell loaded ✓');
})()
